<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J5Uy5V/tc-custom/9780830863945.jpg?1696025265949" alt="This image is the cover for the book The Twelve Disciples, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Twelve Disciples, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>Jesus had about three years to mold a dozen fearful, faithless men into the pillars of a worldwide movement. Despite this brief window, time in Jesus' presence had a transforming effect on each of them, and they would be changed by Jesus' power. In this ten session LifeGuide® Bible Study of Jesus' first followers will transform you too. For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas Connelly
      </h2>
      
      <p class="authorDescription body article"><p>Douglas Connelly (MDiv and MTh, Grace Theological Seminary) is senior pastor at Davison Missionary Church near Flint, Michigan, after serving twelve years as senior pastor at Parkside Community Church in Sterling Heights, Michigan. A writer and speaker, he has written seventeen LifeGuide Bible Studies as well as several books, including <em>The Bible for Blockheads</em> and <em>Angels Around Us.</em> He and his wife Karen have three adult children and six grandchildren.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02fa8c12